import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

import { ApplianceModel } from '@common/models';
import { useApplianceContext } from '@ee-context';
import { useAppSelector } from '@redux/hooks';
import { selectFabricCanvas } from '@redux/slices/fabricSlice';

export interface ApplianceDragableImageProps
    extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    applianceDragSrc?: string;
    applianceModel: ApplianceModel;
}

const ApplianceDragableImage = ({
    applianceModel,
    applianceDragSrc,
    className,
    ...props
}: ApplianceDragableImageProps) => {
    const canvas = useAppSelector(selectFabricCanvas);
    const { updateIsDraggingAppliance, applianceDragStart, isDraggingAppliance } = useApplianceContext();

    return (
        <img
            className={`${className} draggable`}
            draggable="true"
            {...props}
            onDragStart={(e) => {
                if (!isDraggingAppliance) {
                    updateIsDraggingAppliance(true);
                }

                /**
                 * TODO: Remove applianceDragSrc from the component
                 * This is a hack only needed for cooking appliances.
                 */
                if (applianceDragSrc) {
                    const target = document.createElement('img');
                    target.src = applianceDragSrc;
                    target.className = 'draggable';
                    Object.assign(e, { target });
                }

                applianceDragStart(e, applianceModel, canvas.getZoom());
            }}
            onDragEnd={() => {
                updateIsDraggingAppliance(false);
            }}
        />
    );
};

export default ApplianceDragableImage;
